import { useState } from "react";

import mediaService from "../../../services/media/mediaService";
import { toast } from "react-toastify";
import "./ImageUploader.css";

export default function ImageUploader({
    module,
    value,
    onUpload
}) {

    const [uploading, setUploading] = useState(false);

    const handleFileChange = async (e) => {

        const file = e.target.files[0];

        if (!file) return;

        try {

            setUploading(true);

            const response = await mediaService.uploadImage(
                file,
                module
            );

            if (response.success) {

                onUpload(response.data.filePath);

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Image upload failed.");

        }
        finally {

            setUploading(false);

        }

    };

    return (

        <div className="image-uploader">

            {
                value ?

                    <div className="image-preview">

                       <img
    src={
        value.startsWith("http")
            ? value
            : `${process.env.REACT_APP_SERVER_URL}${value}`
    }
    alt="Preview"
    className="img-fluid"
/>

                    </div>

                    :

                    <div className="image-placeholder">

                        No Image

                    </div>

            }

            <div className="mt-2">

                <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={handleFileChange}
                />

            </div>

            {
                uploading &&

                <div className="text-primary mt-2">

                    Uploading...

                </div>

            }

        </div>

    );

}